import React from 'react'
import { OneColorLogoProps, scaleDimensions } from './utils'

export const LgTvLogo: React.FC<OneColorLogoProps> = ({
  height = 32,
  color = '#141414',
  className,
}) => {
  const { width: scaledWidth, height: scaledHeight } = scaleDimensions(
    height,
    47,
    18
  )
  const hex = color

  return (
    <svg
      className={className}
      height={scaledHeight}
      width={scaledWidth}
      aria-label="LGTV"
      viewBox="170 20 280 240"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={hex}
        d="M523.76 156.45h31.071v28.903c-5.702 2.174-16.894 4.35-27.504 4.35-34.368 0-45.797-17.446-45.797-52.874 0-33.811 10.881-53.708 45.216-53.708 19.135 0 29.991 6.004 38.99 17.453l23.741-21.811c-14.497-20.672-39.8-26.937-63.557-26.937-53.413-.021-81.498 29.113-81.498 84.72 0 55.333 25.377 85.328 81.212 85.328 25.639 0 50.697-6.526 64.343-16.09v-80.138h-66.216zm-162.98 30.804h79.071v32.166h-117.23V54.25h38.162zM98.971 112.6a14.738 14.738 0 0 0 13.567-9.15 14.739 14.739 0 0 0-10.79-20.054 14.743 14.743 0 0 0-17.59 14.463 14.765 14.765 0 0 0 4.353 10.439 14.787 14.787 0 0 0 10.46 4.302zm135.1 28.96h-64.955v-9.622h74.475c.101 1.864.152 3.727.152 5.613 0 57.936-47.218 104.9-105.45 104.9-58.234 0-105.46-46.935-105.46-104.9 0-57.96 47.211-104.9 105.45-104.9 1.537 0 3.067.03 4.59.094v9.55a102.677 102.677 0 0 0-4.576-.102c-52.93 0-95.856 42.694-95.856 95.348 0 52.655 42.92 95.357 95.856 95.357 51.482 0 93.54-40.395 95.766-91.07zm-65.103 40.085h-26.104V83.572h-9.651v107.76h9.673v-.065h26.104z"
      />
    </svg>
  )
}
